"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigListItem = exports.ConfigList = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledList = styled_components_1.default.ul `
  list-style: none;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0 -12px;
`;
const StyledListItem = styled_components_1.default.li `
  display: flex;
  flex-direction: column;
  padding: 8px;
  /* border-top: 1px solid #ccc; */
  &.hover:hover {
    background: #f4f4f4;
  }
  &.button {
    cursor: pointer;
  }
  .list-item-icon {
    display: flex;
    align-items: center;
  }
  .list-item-line {
    display: flex;
    align-items: center;
    .list-item-primary {
      flex: 1;
      display: flex;
      align-items: center;
    }
    .list-item-secondary-action {
      padding-right: 4px;
    }
  }
`;
/**
 * Generic List component allowing configuring standard configuration lists. See
 * ConfigListItemProps for details on list item customization. The ConfigList
 * component allows for customizing your own sorting logic. See
 * ConfigSortableList for implementation using dnd-kit.
 */
exports.ConfigList = (0, react_1.forwardRef)((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement(StyledList, Object.assign({ ref: ref, className: `config-list${className ? ` ${className}` : ''}` }, props), children));
});
/**
 * Generic List Item component to be used with ConfigList. The list item
 * standardizes on how configuration lists are implemented. Allows for defining
 * list with icon, primary content, and secondary actions.
 */
exports.ConfigListItem = (0, react_1.forwardRef)((_a, ref) => {
    var { hover, icon, iconProps, primary, secondaryAction, className, children, onClick } = _a, props = __rest(_a, ["hover", "icon", "iconProps", "primary", "secondaryAction", "className", "children", "onClick"]);
    const classes = ['config-list-item'];
    if (className)
        classes.push(className);
    if (hover)
        classes.push('hover');
    if (onClick)
        classes.push('button');
    return (react_1.default.createElement(StyledListItem, Object.assign({ ref: ref, className: classes.join(' '), onClick: onClick }, props),
        react_1.default.createElement("div", { className: 'list-item-line' },
            icon && (react_1.default.createElement("div", Object.assign({ className: 'list-item-icon' }, iconProps), icon)),
            primary && react_1.default.createElement("div", { className: 'list-item-primary' }, primary),
            secondaryAction && (react_1.default.createElement("div", { className: 'list-item-secondary-action' }, secondaryAction))),
        children && react_1.default.createElement("div", { className: 'list-item-body' }, children)));
});
//# sourceMappingURL=ConfigList.js.map